module.exports = __webpack_public_path__ + "static/media/avatar.6aa43802.svg";